// Load utils
import { debounce, updateLayoutVars, setCSSVar, getContainerPosLeft } from "./tools/utils";
import { gridDebug } from "./tools/gridDebug";

// Load components
import { BurgerMenu } from "./components/BurgerMenu";
import { FloatLabel } from "./components/FloatLabel";
import { Favorites } from "./components/Favorites";
import { Wishlist } from "./components/Wishlist";
import { WoocommerceAutoSuggestor } from "./components/WoocommerceAutoSuggestor";
import { NewsletterForm } from "./components/NewsletterForm";
import { Cart } from "./components/Cart";
import { MasonryGrid } from "./components/MasonryGrid";
import { Accordion } from "./components/Accordion";
import { ScrollToTop } from "./components/ScrollToTop";
import { PasswordToggle } from "./components/PasswordToggle";

const canUseScrollReveal = () =>
	typeof window.matchMedia === "function" &&
	window.matchMedia("(width > 768px)").matches &&
	!window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const loadScrollReveal = () => {
	/* global themeVars, __webpack_public_path__ */
	if (typeof themeVars !== "undefined" && themeVars.publicPath) {
		// eslint-disable-next-line no-undef
		__webpack_public_path__ = themeVars.publicPath;
	}

	import(/* webpackChunkName: "scroll-reveal" */ "./components/ScrollReveal").then(({ ScrollReveal }) => {
		ScrollReveal.init();
	});
};

document.addEventListener("DOMContentLoaded", (e) => {
	// Load grid debug on dev environement
	// if (themeVars.is_dev) gridDebug.init();

	// update layout vars
	updateLayoutVars();
	getContainerPosLeft();
	window.addEventListener("resize", debounce(updateLayoutVars, 150));

	// Init components
	BurgerMenu.init();
	FloatLabel.init();
	Favorites.init();
	Wishlist.init();
	WoocommerceAutoSuggestor.init();
	NewsletterForm.init();
	Cart.init();

	Accordion.init();
	ScrollToTop.init();
	PasswordToggle.init();

	// Scroll reveal : chunk async, desktop only — aucun coût JS/réseau sur mobile.
	// Ancre (#…) : chargement immédiat (évite contenu masqué pendant l’idle ~1.8s).
	if (canUseScrollReveal()) {
		if (window.location.hash) {
			loadScrollReveal();
		} else if (typeof window.requestIdleCallback === "function") {
			window.requestIdleCallback(loadScrollReveal, { timeout: 1800 });
		} else {
			window.setTimeout(loadScrollReveal, 1);
		}
	}

	MasonryGrid.init({
		selector: ".wp-block-gallery[data-masonry]",
		gap: 16,
		minColumnWidth: 220,
		columns: 3,
		disableBelow: 600,
	});

	// Sitcky header
	const header = document.querySelector(".header");
	if (header) {
		const headerTop = header.getBoundingClientRect().top;

		setCSSVar("--_header-h", `${header.offsetHeight}px`, "html");

		window.addEventListener("scroll", () => header.classList.toggle("is-sticky", window.scrollY > headerTop + header.offsetHeight));
	}

	new PerformanceObserver((list) => {
		const latestEntry = list.getEntries().at(-1);

		if (latestEntry?.element?.getAttribute("loading") == "lazy") {
			console.warn("Warning: LCP element was lazy loaded", latestEntry);
		}
	}).observe({ type: "largest-contentful-paint", buffered: true });
});
